import * as React from 'react'

import EmployeeLabel from 'modules/surveys/components/Form/CommonEmployeeLabel'
import AnonymousUser from 'modules/surveys/components/Participants/common/AnonymousUser'

import MeAnonymousLabel from 'modules/surveys/components/Participants/common/MeAnonymousLabel'
import type { IQuestionGroupActor } from 'modules/surveys/store/models/QuestionGroup'

interface Props {
  respondent: IQuestionGroupActor | null | undefined
  isAnonymous?: boolean
}

export default function EmployeeLabelWithFallback({ respondent, isAnonymous }: Props) {
  if (respondent && isAnonymous) return <MeAnonymousLabel respondent={respondent} /> // currentUserAnonymous
  if (respondent) return <EmployeeLabel respondent={respondent} />
  return <AnonymousUser />
}
